import { router } from '../router/index.routes';
import { _user, _handler , ServerPing, AkrosPing } from "../classes/index.classes";
import KTAPI from '../api/index.api';

const { io } = window.SocketIO;
const serverURL = "wss://sockets.pdxplay.org:2053";

import { matchSocket } from "../controllers/serverview.controller";
import { playSocket } from '../controllers/pug.controller';
import { streamSocket } from "../controllers/livestream.controller";
import { settingsSocket } from '../controllers/settings.controller';
import { toolbarSocket } from '../controllers/toolbar.controller';
import { offscreenSocket } from '../controllers/offscreen.controller';
import { trainingSocket } from '../controllers/training.controller';
import { pugSocket } from '../controllers/pugb.controller';
import { headerSocket } from '../controllers/header.controller';
import { partySocket } from '../controllers/party.controller';
import { soloSocket } from '../controllers/solo.controller';
import { lobbySocket } from '../controllers/lobby.controller';

let ioPings = {};

let akrosSocket = null;




let ioSocket = {
    socket: null,
    connected: false,
    reconnected: 0,
    inited: false,
    connect: async function () {
        //console.log(this);
        var self = this;
        if (self.socket) {
            self.socket.destroy();
            delete self.socket;
            self.socket = null;
        }
        let token = null;
        //if (await router.checkLogin() && !isTokenExpired(KTCookie.get("token"))) {
        if(_user.authed){
            token = KTCookie.get("token");
        } else {
            token = '';
        }
        //console.log("Before desktop", window.isDesktopApp);
        this.socket = io(serverURL, {
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            reconnectionAttempts: Infinity,
            query:{
                token: token,
                desktop: window.isDesktopApp ? 'true' : 'false'
            },
            transports: ['websocket'],
            //secure: true
        });
        //console.log("Connecting to", serverURL, token);
        this.socket.on('connect', function () {
            if(self.inited){
                console.log('Reconnected');
                self.reconnected++;
            }
            else
            {
                console.log('Connected');
                _user.me.connected = true;
                self.inited = true;
            }            
            
            self.connected = true;
            _handler.emit('socket-connected', this.socket);
        });
        this.socket.on('disconnect', (reason) => {
            self.connected = false;
            console.log('Disconnected', reason);          
        });
        this.socket.on('reconnect', (attempt) => {
            self.reconnected = attempt;
            console.log('Reconnected');
        });
        this.socket.on("reconnect_attempt", (attempt) => {
            self.reconnected = attempt;
            console.log('Reconnect attempt');
        });
        this.socket.on("reconnect_failed", () => {            
            console.log('Reconnect Failed');
        });
        this.socket.on("reconnect_error", (error) => {
            console.log(error);
        });
        this.socket.on('update', function (data) {
            processData(data);
        });

        this.socket.on("sync-game-data", async (data) => {
            console.log("sync...");
            
            if(!_user.authed) return;
            
            _user.inLobby = data.inLobby;
            _user.lobbyInfo = data.lobbyInfo;

        });

    }
}
_handler.emit('socket-init', ioSocket.socket);
$(async function(){    
    //await ioSocket.connect();
    if(!window.isMobile) akrosSocket = new AkrosPing();
});

var onetime = 0;
_handler.on('socket-connected', async () =>{
    if(ioSocket.reconnected == 0)
    {
        ioPings = {};
        let locs = await KTAPI.getLocPool();
        console.log(locs);
        if(locs.message !== 'error')
        {
            locs.res.map(loc =>{
                ioPings[loc] = new ServerPing(loc);
            });
        }
    }
    onetime++;
    if(onetime == 1)
    {
        /**
         * 
         * 
         * GENERAL SOCKET IO EVENTOS
         * 
         * 
         */        


        ioSocket.socket.on("player-join-lobby", async (data) => {
            console.log("player-join-lobby");
            
            if(!_user.authed) return;

            if(data.player.steamid === _user.me.steamid)
            {
                _user.inLobby = true;
                _user.lobbyInfo = data.lobby;
            }

        });

        ioSocket.socket.on("player-leave-lobby", async (data) => {
            console.log("player-leave-lobby");
            if(!_user.authed) return;

            if(data.player.steamid === _user.me.steamid)
            {
                _user.inLobby = false;
                _user.lobbyInfo = {};
            }

        });

        ioSocket.socket.on("player-kick-lobby", async (data) => {
            console.log("player-kick-lobby");
            if(!_user.authed) return;

            if(data.player.steamid === _user.me.steamid)
            {
                _user.inLobby = false;
                _user.lobbyInfo = {};
            }

        });

        ioSocket.socket.on("player-ban-lobby", async (data) => {
            console.log("player-ban-lobby");
            if(!_user.authed) return;

            if(data.player.steamid === _user.me.steamid)
            {
                _user.inLobby = false;
                _user.lobbyInfo = {};
            }

        });

        ioSocket.socket.on("user-connected", async (data) => {
            //console.log("user-connected", data);
            if(_user.authed && _user.me.steamid === data.data.steamid)
            {
                _user.me.connected = true;
                
            }
            $(`.online-badge[steamid="${data.data.steamid}"]`).removeClass("bg-gray-400").addClass("bg-success");
        });

        ioSocket.socket.on("user-disconnected", async (data) => {
            //console.log("user-disconnected", data);
            if(_user.authed && _user.me.steamid === data.data.steamid)
            {
                _user.me.connected = false;
            }
            $(`.online-badge[steamid="${data.data.steamid}"]`).removeClass("bg-success").addClass("bg-gray-400");
        });


        //iniciamos sockets de los controllers        
        playSocket(ioSocket.socket);
        pugSocket(ioSocket.socket);
        trainingSocket(ioSocket.socket);
        matchSocket(ioSocket.socket);
        streamSocket(ioSocket.socket);
        settingsSocket(ioSocket.socket);
        toolbarSocket(ioSocket.socket);
        offscreenSocket(ioSocket.socket);
        headerSocket(ioSocket.socket);
        partySocket(ioSocket.socket);
        soloSocket(ioSocket.socket);
        lobbySocket(ioSocket.socket);
        
    }
});



function processData(data) {
    switch (data.event) {
        case 'render':
            if(data.action == 'text')
            {
                //$(data.element).text(data.content);
            }            
            if(data.action == 'html')
            {
                //$(data.element).html(data.content);
            }
            break;
        
        case 'tokenExpired':

            break;
        default:
            break;
    }
}

 
export {ioSocket};
export {ioPings};
export {akrosSocket};



